module.exports = __webpack_public_path__ + "static/media/leftLog.bd7348d2.png";